import ApiCaller from "../../Connection/ApiCaller";
const apiEndpoint = "web-users";

const onFetchListUser = async () => {
  return await ApiCaller.get("User/GetListUserBase");
};

const onFetchListUserGetSample = async () => {
  return await ApiCaller.get("User/GetListUserBaseGetSample");
};

const onFetchListUserWeb = async (pageSize, pageIndex) => {
  return await ApiCaller.get(`/${apiEndpoint}`, {
      PageSize: pageSize,
      PageIndex: pageIndex,
  });
};

const onFetchListUserWebSearch = async (searchTerm) => {
  return await ApiCaller.get(`/${apiEndpoint}`, { Search: searchTerm });
};

const onFetchListUserWebById = async (id) => {
  return await ApiCaller.get(`/${apiEndpoint}/${encodeURIComponent(id)}`);
};

const onCreateUserWeb = async (data) => {
  return await ApiCaller.post(`/${apiEndpoint}`, data);
};

const onUpdateUser = async (id, data) => {
  return await ApiCaller.put(`/${apiEndpoint}/${encodeURIComponent(id)}`, data);
};

const onResetPassword = async (data) => {
  return await ApiCaller.put(`/web-users/reset-password`, data);
};

const onDeleteUserWeb = async (id) => {
  return await ApiCaller.delete(`/${apiEndpoint}/${encodeURIComponent(id)}`);
};

const onGetListLocation = async (id) => {
  return await ApiCaller.get(`/ViewResult/GetListLocation`);
};

export {
  onFetchListUser,
  onFetchListUserGetSample,
  onFetchListUserWeb,
  onUpdateUser,
  onResetPassword,
  onFetchListUserWebById,
  onCreateUserWeb,
  onDeleteUserWeb,
  onFetchListUserWebSearch,
  onGetListLocation
};
